module.exports = __webpack_public_path__ + "static/media/setting.48947d8d.svg";